export const comparatorPayloadGeneration = ({
  providerWorkflow,
  contractId,
  contactId,
  country,
  address,
  energyType,
  prestationType,
  clientType,
  consumption,
  consumptionData,
  meterOption,
}) => {
  const { carHp, carHc } = consumptionData ?? {}
  const isHphc = meterOption === 'hphc' && (carHp || carHc)

  return {
    workflowName: providerWorkflow || 'default',
    contract_id: contractId,
    contact_id: contactId || null,
    country,
    // France scopes offers by INSEE code, where Italy sends a city id.
    city_id: address.inseeCode || address.cityId || '',
    city: address.city || '',
    zipcode: address.zipcode || '',
    street_name: address.streetName || '',
    energy_type: energyType || '',
    client_type: clientType === 'pro' ? 'business' : 'domestic',
    prestation_type: prestationType || 'cdf',
    meter_option_elec: meterOption || 'base',
    ...(isHphc ? { car_elec_hp: carHp || 0, car_elec_hc: carHc || 0 } : { car_elec_base: consumption.carElec }),
    car_gas: consumption.carGas,
    comparator_mode: true,
  }
}
